import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import moment from 'moment'
import * as firebase from 'firebase'

import TimeFormatter from 'infra/TimeFormatter'
import Config from './PayrollConfig'

class PayrollRow extends React.Component {

  static propTypes = {
    dateStr: PropTypes.string.isRequired,
    workerId: PropTypes.string.isRequired,
    teamId: PropTypes.string.isRequired,
    notes: PropTypes.object
  }

  constructor(props) {
    super(props)
    this.state = {
      data:{}
    }
  }

  componentWillMount() {
    this.prepareData(this.props.dayClocking, this.props.billable, this.props.notes, this.props.signature,
      this.props.workerId, this.props.dateStr, this.props.payrollHeaders)
  }

  getDate = () => {
    return moment(this.props.dateStr)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.workerId !== nextProps.workerId
      || this.props.dayClocking !== nextProps.dayClocking
      || this.props.billable !== nextProps.billable
      || this.props.notes !== nextProps.notes
      || this.props.signature !== nextProps.signature
      || this.props.dateStr !== nextProps.dateStr
      || this.props.payrollHeaders !== nextProps.payrollHeaders) {

      // Update redux
      const toUpdate = {workerId: this.props.workerId, date: this.props.dateStr}
      this.props.dispatch({
        type: 'REPORTS_DELETE_PAYROLL',
        value: toUpdate
      })

      this.prepareData(nextProps.dayClocking, nextProps.billable, nextProps.notes, nextProps.signature,
        nextProps.workerId, nextProps.dateStr, nextProps.payrollHeaders)
    }
  }

  componentWillUnmount(){
    //Update redux
    const toUpdate = {workerId: this.props.workerId, date: this.props.dateStr}
    this.props.dispatch({
      type: 'REPORTS_DELETE_PAYROLL',
      value: toUpdate
    })
  }

  //
  // Process Data Function
  //
  prepareData = (dayClocking, billable, notes, signature, workerId, dateStr, headers) => {
    const data = {}
    headers.forEach(header => {
      if (Config[header]) {
        const formattedData = Config[header].toData(dayClocking, billable, notes, signature)
        data[header] = formattedData
      }
    })

    //Update component state
    this.setState({data})

    //Update Redux
    const toUpdate = {}
    toUpdate[workerId] = {workerId: workerId, date: dateStr, data: data}
    this.props.dispatch({
      type: 'REPORTS_SET_PAYROLL',
      value: toUpdate
    })
  }

  renderCell(value, key) {
    return (
      <div
        key={key}
        style={styles.simpleCell}>
        {value}
      </div>
    )
  }

  renderSignatureImage = data => {
    if (data) {
      const storagePath = 'photos/signatures/' + this.props.teamId + '/' +
        moment(this.props.dateStr).format('YYYY-MM-DD') + '/' + this.props.workerId + '/signature.png'
      firebase.storage().ref(storagePath).getDownloadURL()
        .then(imageUrl => {
          if (this.image) {
            this.image.setAttribute('style', { display: 'block' })
            this.image.setAttribute('src', imageUrl)
          }
        })
    }
    return (
      <div key='signature' style={styles.imageCell}>
        <img ref={img => this.image = img} width={100} height={44} style={{ display: 'none' }} />
      </div>
    )
  }

  renderDate = () => {
    return (
      <div
        key={'date'}
        style={{ display: 'flex', flexGrow: 1, width: 0 }}>
        <div style={{ alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
          <span
            style={{ fontSize: 10, color: '#757575' }}>
            {this.getDate().format('ddd')}
          </span>
          <span
            style={{ fontSize: 20, color: '#757575', fontWeight: '500' }}>
            {this.getDate().format('DD')}
          </span>
          <span
            style={{ fontSize: 10, color: '#757575' }}>
            {this.getDate().format('MMM')}
          </span>
        </div>
      </div>
    )
  }

  formatPercent = (percentage, trailing = 1) => {
    if (percentage) {
      const up = Math.floor(percentage * 10)
      if (up % 10 === 0) {
        return `${up / 10} %`
      }
      return `${(up / 10).toFixed(trailing)} %`
    }
    return null
  }

  formatTime = (minutes) => {
    if (!minutes) {
      return null
    }
    return TimeFormatter.toHoursMinutesFormat(minutes)
  }

  render() {
    const views = []
    const headers = this.props.payrollHeaders.slice()
    headers.unshift('date')
    headers.forEach(header => {
      const data = this.state.data[header]
      switch(header){
        case 'date':
          views.push(this.renderDate())
          break
        case 'time':
          views.push(this.renderCell(data, 'time'))
          break
        case 'lunch':
          views.push(this.renderCell(data, 'lunch'))
          break
        case 'loggedHours':
          views.push(this.renderCell(this.formatTime(data), 'loggedHours'))
          break
        case 'billableHours':
          views.push(this.renderCell(this.formatTime(data), 'billableHours'))
          break
        case 'bwRatio':
          views.push(this.renderCell(this.formatPercent(data), 'bwRatio'))
          break
        case 'notes':
          views.push(this.renderCell(data, 'notes'))
          break
        case 'signature':
          views.push(this.renderSignatureImage(data, 'signature'))
          break
      }
    })
    return (
      <div
        key={this.getDate().format()}
        style={{ display: 'flex', flexDirection: 'row',
          alignItems: 'center', minHeight: 60, paddingLeft: 16, paddingRight: 16,
          backgroundColor: this.props.backgroundColor}}>
        { views }
      </div>
    )
  }
  
}

function mapStateToProps(state){
  const payroll = state.reports.payroll
  const payrollHeaders = state.reports.headers['PAYROLL_HEADERS']
  const props = {}
  if (payroll){
    props['payrollReport'] = payroll
  } else {
    props['payrollReport'] = {}
  }
  if (payrollHeaders && payrollHeaders.columnHeaders){
    props['payrollHeaders'] = payrollHeaders.columnHeaders
  } else {
    props['payrollHeaders'] = []
  }
  return props
}

const styles = {
  simpleCell: {
    display: 'flex',
    flexGrow: 1,
    width: 0,
    fontSize: 14,
    fontWeight: '200',
    color: '#757575',
    marginTop: 4,
    marginBottom: 4
  },
  imageCell: {
    display: 'flex',
    justifyContent: 'center',
    flexGrow: 1,
    width: 0
  }
}

export default connect(mapStateToProps)(PayrollRow)



// WEBPACK FOOTER //
// ./src/reports/payroll/PayrollRow.js